export const getReviewSnippet = (resultDataProducts) => { 
	var arrayForPowerReviews = [],
		resultsHeader =$('.result-header'); 
	if(resultsHeader.length > 0){
		var apiKey = resultsHeader.data('powerreviewsapikey'),
			merchantId = resultsHeader.data('powerreviewsmerchantid'),
			merchantGroupId = resultsHeader.data('powerreviewsmerchantgroupid');
		$.each(resultDataProducts, function(){
			var divForReview = 'category-snippet-' + this.partNumber;
			arrayForPowerReviews.push(
				{
					api_key: apiKey,
				    locale: 'en_US',
				    merchant_id: merchantId,
				    page_id: this.partNumber, 
				    merchant_group_id: merchantGroupId,
				    components: {
				        CategorySnippet: divForReview
				    }
			  	}
			);
		});
		arrayForPowerReviews.on_render = 
			function(config, data) {
//	        	console.log(config);
//	        	console.log(data);
	    	};
		try {
			POWERREVIEWS.display.render(arrayForPowerReviews);
		} catch (err) {
//			console.log(err);
			var newHTML = '<div class="hidden power-reviews-error-tracking">caught exception in _powerReviewSnippets:-' + err + '</div>';
			$('#content-wrapper').append(newHTML);
		}
	}
};